(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9656],{

/***/ 96148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo",
      function () {
        return __webpack_require__(71141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MailResponse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Portal/index.js + 1 modules
var Portal = __webpack_require__(62211);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
;// CONCATENATED MODULE: ./src/assets/Images/mailResponseAnimation.gif
/* harmony default export */ var mailResponseAnimation = ({"src":"/_next/static/media/mailResponseAnimation.d4ad1f5f.gif","height":474,"width":480});
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/MailResponse/MailResponse.jsx










var MailResponse = function(param) {
    var mods = param.mods, title = param.title, body = param.body;
    var className = (0,useMods/* default */.Z)(MailResponse, {
        mods: mods
    }).className;
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var handlClick = function() {
        return setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mailResponseAnimation,
                        alt: "",
                        height: 245,
                        width: 250
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        tag: "h3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        tag: "p",
                        children: body
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        tag: "button",
                        variant: "secondary",
                        onClick: handlClick,
                        children: "OK"
                    })
                ]
            })
        })
    });
};
MailResponse.displayName = "Mail-Response";
MailResponse.propTypes = {
    body: (prop_types_default()).string,
    mods: (prop_types_default()).object,
    title: (prop_types_default()).string
};
MailResponse.defaultProps = {
    mods: {}
};
/* harmony default export */ var MailResponse_MailResponse = (MailResponse);

;// CONCATENATED MODULE: ./src/components/MailResponse/index.js

/* harmony default export */ var components_MailResponse = (MailResponse_MailResponse);


/***/ }),

/***/ 54131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zv": function() { return /* reexport */ Reviews_Reviews; },
  "GI": function() { return /* reexport */ Reviews_ReviewsItem; },
  "jK": function() { return /* reexport */ Reviews_ReviewsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Reviews/Reviews.jsx




var Reviews = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Reviews, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
Reviews.displayName = "Reviews";
Reviews.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Reviews.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Reviews_Reviews = (Reviews);

;// CONCATENATED MODULE: ./src/components/Reviews/ReviewsItem.jsx




var ReviewsItem = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(ReviewsItem, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: className,
        children: children
    });
};
ReviewsItem.displayName = "Reviews-Item";
ReviewsItem.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
ReviewsItem.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Reviews_ReviewsItem = (ReviewsItem);

;// CONCATENATED MODULE: ./src/components/Reviews/ReviewsList.jsx




var ReviewsList = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(ReviewsList, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: className,
        children: children
    });
};
ReviewsList.displayName = "Reviews-List";
ReviewsList.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
ReviewsList.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Reviews_ReviewsList = (ReviewsList);

;// CONCATENATED MODULE: ./src/components/Reviews/index.js






/***/ }),

/***/ 50842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Alert/Alert.jsx






var Alert = function(param) {
    var children = param.children, mods = param.mods, severity = param.severity, startIcon = param.startIcon, endIcon = param.endIcon;
    var className = (0,useMods/* default */.Z)(Alert, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            severity: severity
        })
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        role: "alert",
        children: [
            startIcon,
            children,
            endIcon
        ]
    });
};
Alert.displayName = "Alert";
Alert.propTypes = {
    children: (prop_types_default()).node,
    endIcon: (prop_types_default()).node,
    mods: (prop_types_default()).object,
    severity: (prop_types_default()).string,
    startIcon: (prop_types_default()).node
};
Alert.defaultProps = {
    mods: {},
    severity: "success"
};
/* harmony default export */ var Alert_Alert = (Alert);

;// CONCATENATED MODULE: ./src/components/UI/Alert/index.js

/* harmony default export */ var UI_Alert = (Alert_Alert);


/***/ }),

/***/ 52682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Blockquote; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./src/utils/renderIf.js
var renderIf = __webpack_require__(79810);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
;// CONCATENATED MODULE: ./src/components/UI/Blockquote/BlockquoteAuthor.jsx







var BlockquoteAuthor = function(param) {
    var mods = param.mods, mix = param.mix, author = param.author, config = param.config;
    var className = (0,useMods/* default */.Z)(BlockquoteAuthor, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                tag: "h4",
                children: author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: !(config === null || config === void 0 ? void 0 : config.withoutFrom),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                    children: "from"
                })
            })
        ]
    });
};
BlockquoteAuthor.displayName = "Blockquote__Author";
BlockquoteAuthor.propTypes = {
    author: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
BlockquoteAuthor.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Blockquote_BlockquoteAuthor = (BlockquoteAuthor);

;// CONCATENATED MODULE: ./src/components/UI/Blockquote/BlockquoteBody.jsx




var BlockquoteBody = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(BlockquoteBody, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
BlockquoteBody.displayName = "Blockquote__Body";
BlockquoteBody.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
BlockquoteBody.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Blockquote_BlockquoteBody = (BlockquoteBody);

;// CONCATENATED MODULE: ./src/components/UI/Blockquote/BlockquoteFooter.jsx




var BlockquoteFooter = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(BlockquoteFooter, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
BlockquoteFooter.displayName = "Blockquote__Footer";
BlockquoteFooter.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
BlockquoteFooter.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Blockquote_BlockquoteFooter = (BlockquoteFooter);

;// CONCATENATED MODULE: ./src/components/UI/Blockquote/Blockquote.jsx









var Blockquote = function(param) {
    var mods = param.mods, mix = param.mix, icon = param.icon, body = param.body, author = param.author, reviewLogo = param.reviewLogo, date = param.date, classNameTail = param.className, authorConfig = param.authorConfig;
    var className = (0,useMods/* default */.Z)(Blockquote, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blockquote_BlockquoteBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    tag: "h3",
                    children: body
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Blockquote_BlockquoteFooter, {
                className: "justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blockquote_BlockquoteAuthor, {
                                config: authorConfig,
                                author: author
                            }),
                            reviewLogo
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                        isTrue: date,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[16px] text-neutral-900 font-[400]",
                            children: date
                        })
                    })
                ]
            })
        ]
    });
};
Blockquote.displayName = "Blockquote";
Blockquote.propTypes = {
    author: (prop_types_default()).string.isRequired,
    body: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node,
    icon: (prop_types_default()).node.isRequired,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    reviewLogo: (prop_types_default()).node.isRequired
};
Blockquote.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Blockquote_Blockquote = (Blockquote);

;// CONCATENATED MODULE: ./src/components/UI/Blockquote/index.js

/* harmony default export */ var UI_Blockquote = (Blockquote_Blockquote);


/***/ }),

/***/ 50452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S6": function() { return /* reexport */ Field_FieldFeedback; },
  "Qy": function() { return /* reexport */ Field_FieldLabel; },
  "ZP": function() { return /* binding */ UI_Field; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Field/Field.jsx




var Field = function(param) {
    var children = param.children, mods = param.mods;
    var className = (0,useMods/* default */.Z)(Field, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
Field.displayName = "Field";
Field.propTypes = {
    children: (prop_types_default()).node,
    mods: (prop_types_default()).object
};
Field.defaultProps = {
    mods: {}
};
/* harmony default export */ var Field_Field = (Field);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
;// CONCATENATED MODULE: ./src/components/UI/Field/FieldFeedback.jsx







var FieldFeedback = function(param) {
    var children = param.children, mods = param.mods, invalid = param.invalid, valid = param.valid, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(FieldFeedback, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            invalid: invalid,
            valid: valid
        })
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
FieldFeedback.displayName = "Field__Feedback";
FieldFeedback.propTypes = {
    children: (prop_types_default()).node,
    invalid: (prop_types_default()).bool,
    mods: (prop_types_default()).object,
    valid: (prop_types_default()).bool
};
FieldFeedback.defaultProps = {
    mods: {}
};
/* harmony default export */ var Field_FieldFeedback = (FieldFeedback);

;// CONCATENATED MODULE: ./src/components/UI/Field/FieldLabel.jsx




var FieldLabel = function(param) {
    var children = param.children, mods = param.mods, htmlFor = param.htmlFor, startIcon = param.startIcon, endIcon = param.endIcon;
    var className = (0,useMods/* default */.Z)(FieldLabel, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: className,
        htmlFor: htmlFor,
        children: [
            startIcon,
            children,
            endIcon
        ]
    });
};
FieldLabel.displayName = "Field__Label";
FieldLabel.propTypes = {
    children: (prop_types_default()).node,
    endIcon: (prop_types_default()).node,
    htmlFor: (prop_types_default()).string,
    mods: (prop_types_default()).object,
    startIcon: (prop_types_default()).node
};
FieldLabel.defaultProps = {
    mods: {}
};
/* harmony default export */ var Field_FieldLabel = (FieldLabel);

;// CONCATENATED MODULE: ./src/components/UI/Field/index.js




/* harmony default export */ var UI_Field = (Field_Field);


/***/ }),

/***/ 72720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Input/Input.jsx








var Input = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var mods = param.mods, type = param.type, name = param.name, id = param.id, value = param.value, placeholder = param.placeholder, cols = param.cols, rows = param.rows, autoComplete = param.autoComplete, disabled = param.disabled, required = param.required, search = param.search, searchIcon = param.searchIcon, inputProps = param.inputProps, onChange = param.onChange, onClick = param.onClick, onFocus = param.onFocus, onBlur = param.onBlur, onKeyDown = param.onKeyDown, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Input, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            search: search
        })
    }).className;
    var cn = (0,css/* default */.Z)(className, classNameTail);
    return type == "textarea" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        name: name,
        className: cn,
        id: id,
        ref: ref,
        cols: cols,
        rows: rows,
        placeholder: placeholder,
        required: required,
        disabled: disabled
    }, inputProps), {
        onChange: onChange,
        children: value
    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref,
                type: type,
                name: name,
                className: cn,
                id: id,
                value: value,
                autoComplete: autoComplete,
                placeholder: placeholder,
                required: required,
                disabled: disabled
            }, inputProps), {
                onChange: onChange,
                onClick: onClick,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: onKeyDown
            })),
            searchIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: "search",
                color: "#6E7278",
                size: 16
            })
        ]
    });
});
Input.displayName = "Input";
Input.propTypes = {
    autoComplete: (prop_types_default()).string,
    cols: (prop_types_default()).number,
    disabled: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    inputProps: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    name: (prop_types_default()).string,
    onBlur: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    onClick: (prop_types_default()).func,
    onFocus: (prop_types_default()).func,
    onKeyDown: (prop_types_default()).func,
    placeholder: (prop_types_default()).string,
    required: (prop_types_default()).bool,
    rows: (prop_types_default()).number,
    search: (prop_types_default()).bool,
    searchIcon: (prop_types_default()).bool,
    type: (prop_types_default()).string.isRequired,
    value: (prop_types_default()).any
};
Input.defaultProps = {
    disabled: false,
    mods: {},
    required: false,
    type: "text"
};
/* harmony default export */ var Input_Input = (Input);

;// CONCATENATED MODULE: ./src/components/UI/Input/index.js

/* harmony default export */ var UI_Input = (Input_Input);


/***/ }),

/***/ 45036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Loading; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Loading/Loading.jsx






var Loading = function(param) {
    var mods = param.mods, color = param.color;
    var className = (0,useMods/* default */.Z)(Loading, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            color: color
        })
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};
Loading.displayName = "Loading";
Loading.propTypes = {
    mods: (prop_types_default()).object
};
Loading.defaultProps = {
    mods: {}
};
/* harmony default export */ var Loading_Loading = (Loading);

;// CONCATENATED MODULE: ./src/components/UI/Loading/index.js

/* harmony default export */ var UI_Loading = (Loading_Loading);


/***/ }),

/***/ 71141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ demo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/Layout/index.js + 16 modules
var Layout = __webpack_require__(65305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/Grid/index.js + 1 modules
var Grid = __webpack_require__(4711);
// EXTERNAL MODULE: ./src/components/Info/index.js + 1 modules
var Info = __webpack_require__(54491);
// EXTERNAL MODULE: ./src/components/MailResponse/index.js + 2 modules
var MailResponse = __webpack_require__(60908);
// EXTERNAL MODULE: ./src/components/UI/Alert/index.js + 1 modules
var Alert = __webpack_require__(50842);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/Field/index.js + 3 modules
var Field = __webpack_require__(50452);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/components/UI/Input/index.js + 1 modules
var Input = __webpack_require__(72720);
// EXTERNAL MODULE: ./src/components/UI/Link/index.js + 1 modules
var Link = __webpack_require__(57202);
// EXTERNAL MODULE: ./src/components/UI/Loading/index.js + 1 modules
var Loading = __webpack_require__(45036);
// EXTERNAL MODULE: ./src/components/UI/Picture/index.js + 1 modules
var Picture = __webpack_require__(85593);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Select/Select.jsx






var Select = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var mods = param.mods, name = param.name, id = param.id, autoComplete = param.autoComplete, disabled = param.disabled, required = param.required, selectProps = param.selectProps, options = param.options, onChange = param.onChange;
    var className = (0,useMods/* default */.Z)(Select, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        name: name,
        className: className,
        id: id,
        autoComplete: autoComplete,
        required: required,
        disabled: disabled
    }, selectProps), {
        onChange: onChange,
        defaultValue: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "",
                disabled: true,
                children: "Select"
            }),
            options.map(function(option, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: option.value,
                    children: option.name
                }, index);
            })
        ]
    }));
});
Select.displayName = "Select";
Select.propTypes = {
    autoComplete: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    mods: (prop_types_default()).object,
    name: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func,
    options: (prop_types_default()).array.isRequired,
    required: (prop_types_default()).bool,
    selectProps: (prop_types_default()).object
};
Select.defaultProps = {
    disabled: false,
    mods: {},
    required: false
};
/* harmony default export */ var Select_Select = (Select);

;// CONCATENATED MODULE: ./src/components/UI/Select/index.js

/* harmony default export */ var UI_Select = (Select_Select);

// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge1.svg
var badge1 = __webpack_require__(10129);
var badge1_default = /*#__PURE__*/__webpack_require__.n(badge1);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge2.svg
var badge2 = __webpack_require__(88242);
var badge2_default = /*#__PURE__*/__webpack_require__.n(badge2);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge3.svg
var badge3 = __webpack_require__(25174);
var badge3_default = /*#__PURE__*/__webpack_require__.n(badge3);
;// CONCATENATED MODULE: ./src/assets/Images/personal-product-expert.png
/* harmony default export */ var personal_product_expert = ({"src":"/_next/static/media/personal-product-expert.2ccb1916.png","height":640,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA+0lEQVR42hXJP0sCYRzA8d/L6dl6JTU0F63R1KBBg9IiRNgSFdbipJwd1931hwoJPCiXSESCjIYwNbjT68zE7rH6hp/1I4CgL9SobVTKZlpXL7c1fccjshUgQmAqelZYLma4Py6QT65xbWzC52k47pSUELne4LWAu5OJh806z6VDkotz8cQ/gb5dEUJbf3cMntwC9XyOWn6frdUl4neT6clfYGkih+5dEWM9QTWbonmzBx8O05Nf36owsNGtUnyeTnCVO+CtUYwZufz4lieMXfXVMsPG7RnDXsDukcvC/AbtRysERwkgIsvqodn1vNrLRGRFz8ymPJGsAuQfrMnBOZkxYGIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/layouts/Navigation/Traqq/index.js + 2 modules
var Traqq = __webpack_require__(94665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/form/objectToFormData.js
var objectToFormData = __webpack_require__(61076);
// EXTERNAL MODULE: ./src/utils/renderIf.js
var renderIf = __webpack_require__(79810);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/components/Reviews/index.js + 3 modules
var Reviews = __webpack_require__(54131);
// EXTERNAL MODULE: ./src/components/Section/index.js + 2 modules
var Section = __webpack_require__(62091);
// EXTERNAL MODULE: ./src/components/UI/Blockquote/index.js + 4 modules
var Blockquote = __webpack_require__(52682);
// EXTERNAL MODULE: ./src/components/UI/Container/index.js + 1 modules
var Container = __webpack_require__(76956);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/assets/Images/capterra.svg
var capterra = __webpack_require__(7129);
var capterra_default = /*#__PURE__*/__webpack_require__.n(capterra);
// EXTERNAL MODULE: ./src/assets/Images/capterraLogo.svg
var capterraLogo = __webpack_require__(72735);
var capterraLogo_default = /*#__PURE__*/__webpack_require__.n(capterraLogo);
// EXTERNAL MODULE: ./src/assets/Images/crozdesk.svg
var crozdesk = __webpack_require__(25725);
var crozdesk_default = /*#__PURE__*/__webpack_require__.n(crozdesk);
// EXTERNAL MODULE: ./src/assets/Images/g2-review-stars.svg
var g2_review_stars = __webpack_require__(45876);
var g2_review_stars_default = /*#__PURE__*/__webpack_require__.n(g2_review_stars);
// EXTERNAL MODULE: ./src/assets/Images/softwareAdvice.svg
var softwareAdvice = __webpack_require__(52204);
var softwareAdvice_default = /*#__PURE__*/__webpack_require__.n(softwareAdvice);
// EXTERNAL MODULE: ./src/assets/Images/trustpilot.svg
var trustpilot = __webpack_require__(95768);
var trustpilot_default = /*#__PURE__*/__webpack_require__.n(trustpilot);
// EXTERNAL MODULE: ./src/assets/Images/trustpilotLogo.svg
var trustpilotLogo = __webpack_require__(78293);
var trustpilotLogo_default = /*#__PURE__*/__webpack_require__.n(trustpilotLogo);
// EXTERNAL MODULE: ./src/assets/Images/trustRadius.svg
var trustRadius = __webpack_require__(40322);
var trustRadius_default = /*#__PURE__*/__webpack_require__.n(trustRadius);
;// CONCATENATED MODULE: ./src/screens/Demo/reviews.js








/* harmony default export */ var reviews = ({
    rates: [
        {
            alt: "Software Advice",
            id: 1,
            link: "https://www.softwareadvice.com/hr/traqq-profile/",
            src: (softwareAdvice_default()),
            style: {
                maxWidth: "138px"
            }
        },
        {
            alt: "crozdesk",
            id: 2,
            link: "https://crozdesk.com/software/traqq",
            src: (crozdesk_default()),
            style: {
                maxWidth: "138px"
            }
        },
        {
            alt: "Trustpilot",
            id: 3,
            link: "https://www.trustpilot.com/review/traqq.com",
            src: (trustpilot_default()),
            style: {
                maxWidth: "138px"
            }
        },
        {
            alt: "Capterra",
            id: 4,
            link: "https://www.capterra.com/p/230726/Traqq/",
            src: (capterra_default()),
            style: {
                maxWidth: "138px"
            }
        },
        {
            alt: "TrustRadius",
            id: 5,
            link: "https://www.trustradius.com/products/traqq/reviews",
            src: (trustRadius_default()),
            style: {
                maxWidth: "138px"
            }
        },
        {
            alt: "G2 reviews rating",
            id: 6,
            link: "https://www.g2.com/products/traqq/reviews",
            src: (g2_review_stars_default()),
            style: {
                maxWidth: "138px"
            }
        }
    ],
    services: [
        {
            author: "Adam C.",
            bg: "bg-violet-100",
            body: "Fantastic time tracker at a fantastic value. The dashboard gives you, as an admin, a great breakdown of employee activity. The pricing for the functionality is outstanding as well.",
            iconColor: "violet-500",
            logo: {
                alt: "Capterra",
                image: (capterraLogo_default())
            }
        },
        {
            author: "Maria Garcia",
            bg: "bg-green-100",
            body: "Nice, simple, intuitive. Very handy when you need to work offline with no internet. Love that the screenshots can be deleted by the user.",
            iconColor: "green-500",
            logo: {
                alt: "Trust pilot",
                image: (trustpilotLogo_default())
            }
        }
    ]
});

;// CONCATENATED MODULE: ./src/screens/Demo/Reviews.jsx











var DemoReviews = function() {
    var rates = reviews.rates, services = reviews.services;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-48p",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeadline */.A, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            tag: "h2",
                            mods: {
                                "text-center": true
                            },
                            children: "Traqq always gets rave reviews!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews/* Reviews */.Zv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-wrap gap-x-10p gap-y-24p justify-center 768:gap-x-20p 1280:gap-x-32p",
                            children: rates.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "w-130p 480:w-138p",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: item.link,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item.src,
                                            alt: item.alt
                                        })
                                    })
                                }, item.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-20p 768:flex-row",
                children: services.map(function(review, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col p-24p gap-y-24p rounded-24p basis-full ".concat(review.bg, " 1024:p-40p"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "quote",
                                color: review.iconColor,
                                size: 32,
                                className: "!block"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                children: [
                                    "“",
                                    review.body,
                                    "”"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-8p mt-auto 480:flex-row 480:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            review.author,
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "desktop-body-2",
                                                children: "from"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: review.logo.image,
                                        alt: review.logo.alt,
                                        width: review.logo.width || 108
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Demo_Reviews = (DemoReviews);

;// CONCATENATED MODULE: ./src/screens/Demo/Demo.jsx



























var organizationSizeOptions = [
    {
        name: "1",
        value: "1"
    },
    {
        name: "2 - 10",
        value: "2-10"
    },
    {
        name: "11 - 20",
        value: "11-20"
    },
    {
        name: "21 - 50",
        value: "21-50"
    },
    {
        name: "51 - 100",
        value: "51-100"
    },
    {
        name: "101 - 500",
        value: "101-500"
    },
    {
        name: "500+",
        value: "500+"
    }
];
var Demo = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var recaptchaRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(false), sent = ref7[0], setSent = ref7[1];
    var ref8 = (0,react.useState)({}), response = ref8[0], setResponse = ref8[1];
    var ref9 = (0,react.useState)({}), errors = ref9[0], setErrors = ref9[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var formData, _, _tmp, response, status, data, ref, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!!loading) return [
                            3,
                            9
                        ];
                        setLoading(true);
                        setSent(false);
                        formData = (0,objectToFormData/* default */.Z)(event.target);
                        _ = formData.append;
                        _tmp = [
                            "recaptcha"
                        ];
                        return [
                            4,
                            recaptchaRef.current.executeAsync()
                        ];
                    case 1:
                        _.apply(formData, _tmp.concat(_state.sent()));
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            fetch("".concat("https://traqq.com", "/api/v1/request-demo"), {
                                body: formData,
                                // headers: {
                                //     'X-Requested-With': 'XMLHttpRequest',
                                //     'X-CSRF-TOKEN': token
                                // },
                                method: "POST"
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        status = response.status;
                        if (!(status === 200)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        data = _state.sent();
                        if ((data === null || data === void 0 ? void 0 : data.result) == "success") {
                            setResponse(data.params);
                            setErrors({});
                            setSent(true);
                            event.target.reset();
                        } else {
                            ;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.errors) {
                                setErrors(data.data.errors);
                            } else {
                                router.push("/400");
                            }
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (status === 400) {
                            router.push("/400");
                        } else if (status === 500) {
                            router.push("/500");
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        router.push("/500");
                        return [
                            3,
                            8
                        ];
                    case 8:
                        setLoading(false);
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Traqq/* default */.Z, {
                theme: "dark",
                background: "neutral"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-neutral-900",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,css/* default */.Z)("container", "pt-16p pb-32p mb-48p", "480:pt-24p", "1024:pt-32p", "1280:(pt-40p pb-72p mb-64p)"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,css/* default */.Z)("flex flex-col rounded-16p bg-white px-24p pt-24p pb-32p gap-x-48p gap-y-32p items-start", "480:(px-40p pt-32p pb-40p gap-y-48p)", "768:(p-40p)", "1024:(pt-32p pr-48p flex-row)", "1280:(px-72p pt-48p pb-56p gap-x-88p items-end)"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,css/* default */.Z)("demo__form", "1024:(order-2 pt-16p)"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "h2 768:desktop-heading-2",
                                                children: "Ready to boost your team's performance? Let's talk!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mobile-body-2 768:desktop-body-2",
                                                children: "We at Traqq hate boring marketing presentations. Your business is unique, so let us save you precious time by not talking about how cool we are, but rather focusing on what your team needs. We'll show how Traqq is going to help YOU and your team. \uD83D\uDE09"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        method: "POST",
                                        acceptCharset: "UTF-8",
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                xs: 1,
                                                md: 2,
                                                gx: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.ZP, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldLabel */.Qy, {
                                                                htmlFor: "fullName",
                                                                children: "Full Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "fullName",
                                                                type: "text",
                                                                // placeholder='John Doe'
                                                                id: "fullName",
                                                                mods: {
                                                                    invalid: Boolean(errors.fullName)
                                                                },
                                                                required: true,
                                                                inputProps: {
                                                                    maxLength: 64
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                                isTrue: errors.fullName,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldFeedback */.S6, {
                                                                    invalid: true,
                                                                    children: (ref = errors.fullName) === null || ref === void 0 ? void 0 : ref.join("\n")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.ZP, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldLabel */.Qy, {
                                                                htmlFor: "organizationsName",
                                                                children: "Organization’s Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "organizationsName",
                                                                type: "text",
                                                                // placeholder='Acme Ltd'
                                                                id: "organizationsName",
                                                                mods: {
                                                                    invalid: Boolean(errors.organizationsName)
                                                                },
                                                                required: true,
                                                                inputProps: {
                                                                    maxLength: 64
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                                isTrue: errors.organizationsName,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldFeedback */.S6, {
                                                                    invalid: true,
                                                                    children: (ref1 = errors.organizationsName) === null || ref1 === void 0 ? void 0 : ref1.join("\n")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.ZP, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldLabel */.Qy, {
                                                                htmlFor: "email",
                                                                children: "Work Email Address*"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "email",
                                                                type: "email",
                                                                // placeholder='email@domain.com'
                                                                id: "email",
                                                                mods: {
                                                                    invalid: Boolean(errors.email)
                                                                },
                                                                required: true,
                                                                inputProps: {
                                                                    maxLength: 64
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                                isTrue: errors.email,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldFeedback */.S6, {
                                                                    invalid: true,
                                                                    children: (ref2 = errors.email) === null || ref2 === void 0 ? void 0 : ref2.join("\n")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.ZP, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldLabel */.Qy, {
                                                                htmlFor: "phone",
                                                                children: "Phone (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                name: "phone",
                                                                type: "tel",
                                                                // placeholder='+1 (234) 567-8910'
                                                                id: "phone",
                                                                mods: {
                                                                    invalid: Boolean(errors.phone)
                                                                },
                                                                inputProps: {
                                                                    maxLength: 20
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                                isTrue: errors.phone,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldFeedback */.S6, {
                                                                    invalid: true,
                                                                    children: (ref3 = errors.phone) === null || ref3 === void 0 ? void 0 : ref3.join("\n")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field/* default */.ZP, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldLabel */.Qy, {
                                                                htmlFor: "organizationSize",
                                                                children: "Organization Size*"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_Select, {
                                                                name: "organizationSize",
                                                                id: "organizationSize",
                                                                mods: {
                                                                    invalid: Boolean(errors.organizationSize)
                                                                },
                                                                options: organizationSizeOptions,
                                                                required: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                                isTrue: errors.organizationSize,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* FieldFeedback */.S6, {
                                                                    invalid: true,
                                                                    children: (ref4 = errors.organizationSize) === null || ref4 === void 0 ? void 0 : ref4.join("\n")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "desktop-body-4 text-neutral-700",
                                                children: [
                                                    "By requesting a demo, I confirm that I have read and agree to ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "/legal/terms",
                                                        mods: {
                                                            violet: true
                                                        },
                                                        children: "Legal Terms"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                                ref: recaptchaRef,
                                                sitekey: "6LfYhg4jAAAAAPuFKh7RagIXTDT5k1yIXyM0I2gp",
                                                size: "invisible"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                                                isTrue: errors.recaptcha,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                                    severity: "danger",
                                                    children: (ref5 = errors.recaptcha) === null || ref5 === void 0 ? void 0 : ref5.join("\n")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "submit",
                                                variant: "primary",
                                                mods: {
                                                    "block": true,
                                                    "mt-8": true
                                                },
                                                className: "button_md",
                                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : "Request demo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,css/* default */.Z)("flex flex-col gap-8p", "480:(gap-y-16p)", "768:(flex-row)", "1024:(flex-col gap-y-8p)"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,css/* default */.Z)("flex flex-col gap-8p", "480:(flex-row)", "1024:(flex-col)"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                                        image: personal_product_expert,
                                                        alt: "You personal Product Expert",
                                                        className: "480:!w-144p 1024:!w-288p 1280:!w-320p"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        name: "quote",
                                                        color: "green-900",
                                                        size: 24,
                                                        mods: {
                                                            "bg-white": true
                                                        },
                                                        className: "w-24p h-24p box-content p-12p -mt-[9%] z-10 rounded-full"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,css/* default */.Z)("text-center pt-8p pb-16p", "480:(text-left px-16p)", "1024:(pt-0 px-20p text-center)", "1280:(px-24p)"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "mb-16p",
                                                        children: "Not sure about the date and time yet? No problem, I'm totally flexible with it."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "desktop-subtitle",
                                                        children: "Sebastian Ray"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "desktop-body-4 text-neutral-700",
                                                        children: "You personal Product Expert"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,css/* default */.Z)("border-t h-fit border-neutral-300 pt-32p pb-8p", "768:(border-t-0 border-l pl-24p pt-16p)", "1024:(border-l-0 border-t pt-24p pb-0 px-20p whitespace-nowrap)", "1280:(px-24p)"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-center gap-x-16p mb-24p 768:mb-16p",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (badge1_default()),
                                                        alt: "G2 Easiest Admin",
                                                        className: (0,css/* default */.Z)("max-w-none w-66p h-70p", "480:(w-88p h-94p)", "768:(w-56p h-60p)", "1024:(w-72p h-78p)")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (badge2_default()),
                                                        alt: "G2 Users Love Us",
                                                        className: (0,css/* default */.Z)("max-w-none w-66p h-70p", "480:(w-88p h-94p)", "768:(w-56p h-60p)", "1024:(w-72p h-78p)")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (badge3_default()),
                                                        alt: "G2 High Performer",
                                                        className: (0,css/* default */.Z)("max-w-none w-66p h-70p", "480:(w-88p h-94p)", "768:(w-56p h-60p)", "1024:(w-72p h-78p)")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "desktop-subtitle text-center 768:text-left 1024:text-center",
                                                children: "More than 50,000 users trust Traqq"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Demo_Reviews, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: sent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MailResponse/* default */.Z, {
                    title: response.title,
                    body: response.body
                })
            })
        ]
    });
};
/* harmony default export */ var Demo_Demo = (Demo);

;// CONCATENATED MODULE: ./src/screens/Demo/index.js

/* harmony default export */ var screens_Demo = (Demo_Demo);

;// CONCATENATED MODULE: ./src/pages/demo.js




var title = "Get a FREE Demo";
var description = "Get the demo version of our Traqq app and experience seamless time tracking and remote employee management. Zero commitments or obligations!";
var DemoPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        title: title,
        description: description,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(screens_Demo, {})
    });
};
/* harmony default export */ var demo = (/*#__PURE__*/(0,react.memo)(DemoPage));


/***/ }),

/***/ 61076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var objectToFormData = function(data) {
    var formData = new FormData();
    Object.keys(data).forEach(function(key) {
        var _key = data[key], name = _key.name, value = _key.value;
        if (name && value && name !== undefined && name !== "") formData.append(name, value);
    });
    return formData;
};
/* harmony default export */ __webpack_exports__["Z"] = (objectToFormData);


/***/ }),

/***/ 72735:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 78293:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5646,1608,2932,5555,4665,1295,9774,2888,179], function() { return __webpack_exec__(96148); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);